import { twMerge } from "tailwind-merge";
import { UnreadDotBase, type UnreadDotBaseProps } from "@core/ui";

export type Props = UnreadDotBaseProps;

/**
 * Styled unread dot wrapping `UnreadDotBase`. Small filled red circle —
 * a presence-only indicator with no count. Render inline beside the
 * label of whatever surface needs to flag "this has unread."
 */
export function UnreadDot({ hasUnread, className, ...props }: Props) {
  return (
    <UnreadDotBase
      hasUnread={hasUnread}
      className={twMerge(
        "inline-block w-2 h-2 rounded-full bg-red-600",
        className
      )}
      data-testid="unread-dot"
      {...props}
    />
  );
}

export default UnreadDot;
